import { createFileRoute } from '@tanstack/react-router'
import { InvoicesPage } from '@/features/invoices/list/invoices-page'

export const Route = createFileRoute('/_authenticated/invoices/')({
  staticData: { title: 'AP Invoices' },
  component: InvoicesPage,
})
